<template>
  <div class="MinifyChartsContainer" :class="position">
    <div
      class="minify-charts"
      :style="{
        maxWidth: `${$h_Ratio(160, $store)}px`,
        height: `${$h_Ratio(30, $store)}px`,
        lineHeight: `${$h_Ratio(24, $store)}px`,
        padding: `${$h_Ratio(2, $store)}px`,
        [`padding-${position === 'left' ? 'right' : 'left'}`]: `${$h_Ratio(40, $store)}px`,
        [`padding-${position}`]: `${$h_Ratio(5, $store)}px`,
        fontSize: `${$h_Ratio(15, $store)}px`,
        border: `${$h_Ratio(2, $store)}px solid #06d2d5`,
        margin: `${$h_Ratio(6, $store)}px ${$h_Ratio(5, $store)}px`,
        // transform: `scale(${$h_Ratio(1, $store)})`,
      }"
      @click.stop="setCurrentConfigration(item)"
      :class="'ac-' + position"
      v-for="item in minifyCharts"
      :key="item.id"
    >
      <span class="normalize-charts-title">
        {{ item.propertyData.titleText.value }}
      </span>
      <span
        class="normalize-charts"
        @click="handleSetChartsNormal(item.id)"
        :style="{
          position: 'absolute',
          paddingLeft: `${$h_Ratio(5, $store)}px`,
          paddingRight: `${$h_Ratio(5, $store)}px`,
          [`${position === 'left' ? 'right' : 'left'}`]: `${$h_Ratio(4, $store)}px`,
          width: `${$h_Ratio(20, $store)}px`,
          height: `${$h_Ratio(16, $store)}px`,
        }"
      >
        <img src="@/assets/img/chartsController/normalize.png" />
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MinifyChartsContainer',
  props: {
    position: {
      type: String,
      default: 'left',
    },
    currentCharts: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  setup() {},
  data() {
    return {
      minifyCharts: [],
    };
  },
  created() {
    this.debounce_countShowMinifyCharts = this.$_.debounce(this.countShowMinifyCharts, 300);
  },
  beforeMount() {},
  mounted() {
    this.countShowMinifyCharts();
  },
  unmounted() {},
  watch: {
    currentCharts: {
      deep: true,
      handler: function () {
        this.debounce_countShowMinifyCharts();
      },
    },
  },
  computed: {},
  methods: {
    countShowMinifyCharts() {
      this.minifyCharts = [];
      this.currentCharts.forEach(item => {
        if (item.propertyData.showStatus.value === `minify-${this.position}`) {
          this.minifyCharts.push(item);
        }
      });
    },

    setCurrentConfigration(configuration) {
      this.$store.commit('set_CurrentConfigration', configuration);
    },
    handleSetChartsNormal(id) {
      this.$store.commit('set_chartsShowStatus', {
        id,
        status: 'norm',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.MinifyChartsContainer {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  .minify-charts {
    box-sizing: border-box;
    position: relative;
    .normalize-charts-title {
      width: 90%;
      height: 100%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      margin: 0;
    }
    .normalize-charts {
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      &:hover {
        background-color: rgba(64, 176, 114, 0.38);
      }
    }
    span {
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.left {
  left: 0;
}

.right {
  right: 0;
}
</style>
